import { Button, ButtonRow, ContextMenu, ContextMenuItem, FormCheckboxInput, FormTextAreaInput, FormTextInput, Heading } from "cai-fusion";
import { useState } from "react";
import { useIntegration } from "../../../../contexts/IntegrationContext";

import { ReactComponent as IconTrash } from "../../../../../../images/icon-trash.svg";
import { ReactComponent as IconDraft } from "../../../../../../images/icon-draft.svg";

const IntegrationTools = () => {
    
    const EMPTY_TOOL = {
        "id": undefined,
        "integrationId": undefined,
        "endpoint": "",
        "title": "",
        "description": "",
    }

    const [isCreatingTool, setIsCreatingTool] = useState(false);
    const [newTool, setNewTool] = useState({...EMPTY_TOOL})

    const {currIntegration, createTool, currTools} = useIntegration();

    return (
        <div>
            <div className="m-heading-row m-heading-row--secondary">
                <div className="m-heading-row__title">
                    <Heading size={4}>Tools</Heading>
                    <p className="a-muted-text">Define tools that will be available for AI assistants when using this data connection.</p>
                </div>
                <div className="m-heading-row__actions">
                    <Button children="Add Tool" outline onClick={() => setIsCreatingTool(true)}/>
                </div>
            </div>

            {isCreatingTool && 
                <div className="o-block o-block--body l-mb-sm">
                    <FormTextInput 
                        displayName="Title"
                        placeholder="e.g., Search Customer Database"
                        formValue={newTool?.title}
                        onInputChange={(_f, newVal) => setNewTool({...newTool, "title": newVal})}
                    />
                    <FormTextAreaInput 
                        rows={6}
                        displayName="Description"
                        placeholder="Provide detailed information including data dictionaries, endpoint definitions, and guidance on when to use this tool..."
                        formValue={newTool?.description}
                        onInputChange={(_f, newVal) => setNewTool({...newTool, "description": newVal})}
                    />
                    <FormTextInput 
                        displayName="Endpoint"
                        formValue={newTool?.endpoint}
                        onInputChange={(_f, newVal) => setNewTool({...newTool, "endpoint": newVal})}
                    />
                    {/* <FormCheckboxInput 
                        displayName="Requires approval before execution"
                        formValue={newTool?.requiresApproval}
                        onInputChange={(_f, newVal) => setNewTool({...newTool, "requiresApproval": newVal})}
                    /> */}
                    <ButtonRow>
                        <Button outline children="Cancel" onClick={() => {setIsCreatingTool(false); setNewTool({...EMPTY_TOOL})}}/>
                        <Button children="Create" onClick={() => {createTool(newTool); setIsCreatingTool(false); setNewTool({...EMPTY_TOOL})}} />
                    </ButtonRow>
                </div>
            }

            {currTools?.map((tool) => (
                <ToolItem toolObj={tool} key={tool?.id} />
            ))}
        </div>
    )
}


const ToolItem = ({toolObj}) => {
    const [isEditing, setIsEditing] = useState(false);
    const {updateTool, deleteTool} = useIntegration();

    const [editToolObj, setEditToolObj] = useState({...toolObj});

    const [contextMenuIsHidden, setContextMenuIsHidden] = useState(true);

    if (!isEditing) {
        return (
            <div className="o-block o-block--body l-mb-sm" key={toolObj?.title}>
                <div className="row">
                    <div className="col-10">
                        <Heading size={4}>{toolObj?.title}</Heading>
                        <p>{toolObj?.description}</p>
                        <p>Endpoint: {toolObj?.endpoint}</p>
                        {/* <FormCheckboxInput 
                            disabled
                            displayName="Requires approval before execution"
                            formValue={toolObj?.requiresApproval} 
                        /> */}
                    </div>
                    <div className="col-2 h-vert-center-right">
                        <ContextMenu
                            isHidden={contextMenuIsHidden}
                            onClick={() => setContextMenuIsHidden(!contextMenuIsHidden)}
                            onBlur={() => setContextMenuIsHidden(true)}
                        >
                            <ContextMenuItem 
                                Icon={IconDraft}
                                name="Edit Tool"
                                onClick={() => {
                                    setEditToolObj({...toolObj});
                                    setIsEditing(true);
                                    setContextMenuIsHidden(true);
                                }}
                            />
                            <ContextMenuItem
                                Icon={IconTrash}
                                danger
                                name="Delete Tool"
                                onClick={() => {
                                    deleteTool(toolObj?.id);
                                    setContextMenuIsHidden(true);
                                }}
                            />
                        </ContextMenu>
                    </div>
                </div>
            </div>
        )
    } else {
        return (
            <div className="o-block o-block--body l-mb-sm">
                <FormTextInput 
                    displayName="Title"
                    placeholder="e.g., Search Customer Database"
                    formValue={editToolObj?.title}
                    onInputChange={(_f, newVal) => setEditToolObj({...editToolObj, "title": newVal})}
                />
                <FormTextAreaInput 
                    rows={6}
                    displayName="Description"
                    placeholder="Provide detailed information including data dictionaries, endpoint definitions, and guidance on when to use this tool..."
                    formValue={editToolObj?.description}
                    onInputChange={(_f, newVal) => setEditToolObj({...editToolObj, "description": newVal})}
                />
                <FormTextInput 
                    displayName="Endpoint"
                    formValue={editToolObj?.endpoint}
                    onInputChange={(_f, newVal) => setEditToolObj({...editToolObj, "endpoint": newVal})}
                />
                {/* <FormCheckboxInput 
                    displayName="Requires approval before execution"
                    formValue={editToolObj?.requiresApproval}
                    onInputChange={(_f, newVal) => setEditToolObj({...editToolObj, "requiresApproval": newVal})}
                /> */}
                <ButtonRow>
                    <Button outline children="Cancel" onClick={() => {setIsEditing(false); setEditToolObj({...toolObj})}}/>
                    <Button children="Update" onClick={() => {updateTool(editToolObj); setIsEditing(false); setEditToolObj({...toolObj})}} />
                </ButtonRow>
            </div>
        )
    }
}

export default IntegrationTools;